import React from 'react';
import { FormikProps } from 'formik';
import ATMLoadingButton from 'src/components/UI/atoms/ATMLoadingButton/ATMLoadingButton';
import ATMTextField from 'src/components/UI/atoms/formFields/ATMTextField/ATMTextField';
import { ChannelFormValues } from 'src/models/Channel.model';

type Props = {
    formikProps: FormikProps<ChannelFormValues>;
    onClose: () => void;
    formType?: string;

};

const ChannelForm = ({ formikProps, onClose, formType }: Props) => {
    const { values, setFieldValue, isSubmitting, handleBlur } = formikProps;

    return (
        <div className='p-4 flex flex-col gap-6'>
            <div className='flex justify-between items-center'>
                <div className='text-xl font-medium'>  {formType} Channel </div>
                <button type='button' className='hover:bg-hover' onClick={onClose}>
                    Cancel
                </button>
            </div>
            <div className='flex flex-col gap-4'>
                <div>
                    <ATMTextField
                        name='channelName'
                        value={values.channelName}
                        onChange={(e) => {
                            setFieldValue('channelName', e.target.value);
                        }}
                        placeholder='Enter channel name'
                        label='Channel Name'
                        onBlur={handleBlur}
                    />
                </div>

            </div>
            <div>
                <ATMLoadingButton isLoading={isSubmitting} type='submit'>
                    Save
                </ATMLoadingButton>
            </div>
        </div>
    );
};

export default ChannelForm;